import React from 'react';
import {Box, Stack, styled} from '@mui/material';
import {Headline} from '@lightricks/react-design-system';
import Guide from '@contentlab/components/feature-editor/components/file-upload/Guide';
import {DraftCaptionsProject} from '@contentlab/stores/contentLabStore';
import {CaptionsStylePreset} from '@contentlab/types/captions';
import translate from '@/utils/translate';
import {CaptionsTab} from '../../types';
import CaptionsMenu from '../captions-menu';

const Container = styled(Box)(() => ({
  boxSizing: 'border-box',
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: '24px 0 24px 24px',
  gap: '16px',
}));

function CaptionsContent({
  draftCaptionsProject,
  projectId,
  currentIndex,
  setCurrentIndex,
  captionStyles,
  onStyleChange,
  onTranscriptionChange,
  onCustomizeStyle,
  activeTab,
  setActiveTab,
}: {
  draftCaptionsProject: DraftCaptionsProject;
  projectId: string;
  currentIndex: string | null;
  setCurrentIndex: (index: string | null) => void;
  captionStyles: CaptionsStylePreset[];
  onStyleChange?: () => void;
  onTranscriptionChange?: () => void;
  onCustomizeStyle?: (style: CaptionsStylePreset) => void;
  activeTab: CaptionsTab;
  setActiveTab: (tab: CaptionsTab) => void;
}) {
  return (
    <Container>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        paddingInlineEnd="24px"
      >
        <Headline size="md">{translate('Customize Your Captions')}</Headline>
      </Stack>

      <Box sx={{flex: 1, minHeight: 0, overflow: 'hidden'}}>
        <CaptionsMenu
          projectId={projectId}
          draftCaptionsProject={draftCaptionsProject}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          captionStyles={captionStyles}
          onStyleChange={onStyleChange}
          onTranscriptionChange={onTranscriptionChange}
          onCustomizeStyle={onCustomizeStyle}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </Box>
    </Container>
  );
}

export default CaptionsContent;
